import React from 'react';

// Default value is defined in QueryStringContextProvider
export const QueryStringContext = React.createContext({});
